import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, UserPlus, IndianRupee, BriefcaseBusiness } from "lucide-react";

export default function FounderDashboard() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [finance, setFinance] = useState(null);
  const [financeError, setFinanceError] = useState("");
  useEffect(() => {
    api.get("/founder/summary")
      .then(r => setData(r.data))
      .catch(() => setError("Unable to load founder summary"));
  }, []);
  useEffect(() => {
    api.get("/finance/summary").then(r => setFinance(r.data))
      .catch(() => setFinanceError("Unable to load expense summary"));
  }, []);
  const money = value => value == null ? "—" : "₹" + (value / 100).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const cards = [
    ["Total Students", data?.total_students, Users],
    ["Admission Enquiries", data?.total_enquiries, UserPlus],
    ["Unpaid Fee Records", data?.pending_fee_records, IndianRupee],
    ["Total Staff", data?.total_staff, BriefcaseBusiness]
  ];
  return <div className="space-y-6">
    <h1 className="text-3xl font-black">Founder Dashboard</h1>
    <p className="text-muted-foreground">Kidzkulam Business Overview</p>
    {error && <p role="alert" className="text-red-600">{error}</p>}
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
      {cards.map(([label,value,Icon]) =>
        <Card key={label}><CardHeader><CardTitle className="text-sm flex items-center gap-2"><Icon size={18}/>{label}</CardTitle></CardHeader>
        <CardContent className="text-3xl font-bold">{value ?? "—"}</CardContent></Card>
      )}
    </div>
    <h2 className="text-xl font-bold">Expense Overview</h2>
    {financeError && <p role="alert" className="text-red-600">{financeError}</p>}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {[
        ["Pending Approval", finance?.pending_paise],
        ["Approved • Unpaid", finance?.approved_unpaid_paise],
        ["Recorded Payments", finance?.paid_paise]
      ].map(([label, amount]) => <Card key={label}><CardHeader><CardTitle className="text-sm">{label}</CardTitle></CardHeader><CardContent className="text-2xl font-bold">{money(amount)}</CardContent></Card>)}
    </div>
    <p className="text-sm text-muted-foreground">These are expense figures only, not school profit or cash balance. Fee-income reconciliation will be added separately.</p>
  </div>;
}
